import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Popconfirm,
  Row,
  Table,
} from "antd";
import { CREATE_jwel, tenantName } from "../../../Config/Config";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";

const HoldSelectDialog = ({
  holdOpen,
  setHoldOpen,
  holdData,
  setHoldData,
  filteredHoldData,
  setFilteredHoldData,
  selectedHoldRowKeys,
  handleSearchHoldInput,
  handleCheckboxChangeHold,
  handleReset,
  setSearchHoldText,
  searchHoldText,
  filterDataByHoldNo,
  setHNo,
  deleteBarcodeMastHoldAPI,
  deleteBarcodeDetHoldAPI,
  modifyHoldDetAPI,
  //   billItemAPI,
  //   billPaymentsAPI,
  //   billCustLedgerAPI,
}) => {
  const searchInputRef = useRef(null);
  const submitBillNoRef = useRef(null);

  const handleDelete = (hold) => {
    deleteBarcodeMastHoldAPI(hold);
    deleteBarcodeDetHoldAPI(hold);
  };
  const handleHoldDelete = (billno) => {
    // remove from main data
    setHoldData((prev) => prev.filter((item) => item.billno !== billno));

    // remove from filtered data
    setFilteredHoldData((prev) =>
      prev.filter((item) => item.billno !== billno)
    );
  };

  const columns3 = [
    {
      title: "S.No",
      dataIndex: "sno",
      width: 50,
      key: "sno",
      className: "blue-background-column",
      render: (_, __, index) => index + 1,
    },
    {
      title: "",
      dataIndex: "checkbox",
      width: 50,
      key: "checkbox",
      render: (_, record) => (
        <Checkbox
          checked={selectedHoldRowKeys.includes(record.billno)}
          onChange={() => handleCheckboxChangeHold(record.billno)}
          onKeyDown={(e) => {
            handleKeyDown(e, submitBillNoRef);
          }}
        />
      ),
    },
    {
      title: "HoldNo",
      dataIndex: "billno",
      key: "billno",
      className: "blue-background-column",
      render: (text) => (
        <span style={{ fontWeight: "bold", fontSize: "16px" }}>{text}</span>
      ),
    },
    {
      title: "Actions",
      key: "actions",

      align: "left",
      width: 70,
      render: (_, record, index) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "left",
              justifyItems: "center",
              gap: "5px",
            }}
          >
            <Popconfirm
              title="Are you sure you want to delete?"
              onConfirm={() => {
                handleDelete(record?.billno);
                handleHoldDelete(record?.billno);
              }}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="link"
                danger
                icon={<DeleteOutlined />}
                style={{ fontSize: "16px" }}
              />
            </Popconfirm>
          </div>
        );
      },
    },
    {
      title: "Cust Name",
      dataIndex: "CustName",
      key: "CustName",
      width: "300px",
    },
    { title: "Mobile No", dataIndex: "PhoneNo", key: "PhoneNo" },

    {
      title: "Inv Date",
      dataIndex: "billdate",
      key: "billdate",
      render: (text) =>
        text
          ? new Date(text).toLocaleDateString("en-GB").replace(/\//g, "-")
          : "N/A",
    },
    {
      title: "Total Qty",
      dataIndex: "TOTQTY",
      key: "TOTQTY",
      align: "right",
    },
    {
      title: "Dis.Amt",
      dataIndex: "discount",
      key: "discount",
      align: "right",
      render: (text) => Number(text).toFixed(2),
    },
    {
      title: "Net Amt",
      dataIndex: "finalamt",
      key: "finalamt",
      align: "right",
      render: (text) => Number(text || 0).toFixed(2),
    },
  ];

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <Modal
      title="Hold Details"
      open={holdOpen}
      onCancel={() => {
        setHoldOpen(false);
        // handleReset();
        setSearchHoldText();
        filterDataByHoldNo();
        handleCheckboxChangeHold();
      }}
      footer={null}
      width="80%"
      maskStyle={{
        backdropFilter: "blur(8px)", // <- this applies the blur effect
        backgroundColor: "rgba(0, 0, 0, 0.2)", // optional: tint the background a little
      }}
    >
      <Row
        justify="center"
        align="middle"
        gutter={16}
        style={{ marginBottom: 10 }}
      >
        <Col>
          <Form.Item
            label="Hold No"
            style={{ fontWeight: "bold", marginBottom: 0 }}
          >
            <Input
              ref={searchInputRef}
              placeholder="Search Hold No"
              value={searchHoldText}
              onChange={(e) => handleSearchHoldInput(e)}
              onFocus={(e) => e.target.select()}
              onKeyDown={(e) => handleKeyDown(e, submitBillNoRef)}
              style={{ fontWeight: "bold" }}
            />
          </Form.Item>
        </Col>
        <Col>
          <Button
            ref={submitBillNoRef}
            type="primary"
            onClick={() => {
              modifyHoldDetAPI(searchHoldText);
              //   billItemAPI(searchText);
              //   billPaymentsAPI(searchText);
              //   billCustLedgerAPI(searchText);
              setHNo(searchHoldText);
              setHoldOpen(false);
            }}
          >
            Submit
          </Button>
        </Col>
      </Row>

      <Table
        dataSource={
          filteredHoldData.length > 0 || searchHoldText
            ? filteredHoldData
            : holdData
        } // Use filteredData if available
        columns={columns3}
        rowKey="BillNo"
        size="small"
        className="custom-table"
        //   loading={loading}
        pagination={false} // Disable pagination
        scroll={{ y: 300 }} // Enable vertical scroll
      />
    </Modal>
  );
};

export default HoldSelectDialog;
